export default "__VITE_ASSET__2049dd26__"